/**
 * @generated SignedSource<<f639944e87da2f9821ee64159a38d0a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type SourceType = "OTHER" | "QUIZ" | "REDEMPTION" | "SURVEY";
import { FragmentRefs } from "relay-runtime";
export type TransactionHistoryFragment$data = {
  readonly walletTransactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly amount: {
          readonly formatted: string;
        };
        readonly createdAt: string;
        readonly description: string;
        readonly eventType: string;
        readonly id: string;
        readonly sourceType: SourceType;
        readonly supportId: string;
      };
    }>;
    readonly pageInfo: {
      readonly hasNextPage: boolean | null;
    };
  } | null;
  readonly " $fragmentType": "TransactionHistoryFragment";
};
export type TransactionHistoryFragment$key = {
  readonly " $data"?: TransactionHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TransactionHistoryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "walletTransactions"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./TransactionHistoryFragmentRefetchQuery.graphql')
    }
  },
  "name": "TransactionHistoryFragment",
  "selections": [
    {
      "alias": "walletTransactions",
      "args": null,
      "concreteType": "WalletTransactionConnection",
      "kind": "LinkedField",
      "name": "__TransactionHistoryFragment_walletTransactions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletTransactionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WalletTransaction",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CurrencyAmount",
                  "kind": "LinkedField",
                  "name": "amount",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formatted",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "eventType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourceType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "d14cffa7eb0ae3fe6799a43a9b2ff471";

export default node;
